module.exports = __webpack_public_path__ + "static/media/spring-boot.0777d8c8.svg";